module.exports = __webpack_public_path__ + "static/media/profile_pic.ed09dbaf.png";